import {
  INVOICE_CREATE_REQUEST,
  INVOICE_CREATE_SUCCESS,
  INVOICE_CREATE_FAIL,
  INVOICE_LIST_REQUEST,
  INVOICE_LIST_SUCCESS,
  INVOICE_LIST_FAIL,
  INVOICE_LIST_ALL_REQUEST,
  INVOICE_LIST_ALL_SUCCESS,
  INVOICE_LIST_ALL_FAIL,
  INVOICE_UPDATE_REQUEST,
  INVOICE_UPDATE_SUCCESS,
  INVOICE_UPDATE_FAIL,
} from '../actions/types';

const initialState = {
  loading: false,
  loadingUpdate: false,
  invoice: null,
  invoices: [],
  error: null,
};

export const invoiceReducer = (state = initialState, action) => {
  // console.log(`[REDUCER] invoiceReducer received action: ${action.type}`);

  switch (action.type) {
    case INVOICE_CREATE_REQUEST:
      return { ...state, loading: true };
    case INVOICE_CREATE_SUCCESS:
      return { ...state, loading: false, invoice: action.payload, error: null };
    case INVOICE_CREATE_FAIL:
      return { ...state, loading: false, error: action.payload };

    case INVOICE_LIST_REQUEST:
    case INVOICE_LIST_ALL_REQUEST:
      return { ...state, loading: true, invoices: [], error: null };

    case INVOICE_LIST_SUCCESS:
    case INVOICE_LIST_ALL_SUCCESS:
      return { ...state, loading: false, invoices: action.payload };

    case INVOICE_LIST_FAIL:
    case INVOICE_LIST_ALL_FAIL:
      return { ...state, loading: false, error: action.payload, invoices: [] };
    
    case INVOICE_UPDATE_REQUEST:
      return { ...state, loadingUpdate: true };

    // ✅ REMOVED the CHECK_PAYOUT_STATUS_SUCCESS case.
    // The component will dispatch a dedicated INVOICE_LIST action instead.
    case INVOICE_UPDATE_SUCCESS:
      return {
          ...state,
          loadingUpdate: false,
          invoices: state.invoices.map((invoice) =>
              invoice.id === action.payload.id ? action.payload : invoice
          ),
      };

    case INVOICE_UPDATE_FAIL:
      return { ...state, loadingUpdate: false, error: action.payload };

    default:
      return state;
  }
};